import NoData from "@/components/client/NoData";
import ICON_ARROW_UP_LEAGUES from "@/public/arrow_up_white_leagues.svg";
import ICON_ARROW_DOWN_LEAGUES from "@/public/arrow_down_white_leagues.svg";
import CollapsiblePanel from "@/components/client/CollapsiblePanel";

const IMAGE_ARROW_DOWN_LEAGUES = ICON_ARROW_DOWN_LEAGUES;
const IMAGE_ARROW_UP_LEAGUES = ICON_ARROW_UP_LEAGUES;

export default function RecentMatchData({ matchAnalysis }) {
  const recentTeamPerf = matchAnalysis?.recentTeamPerf || [];

  if (!recentTeamPerf.length) {
    return (
      <CollapsiblePanel title="Dữ liệu đội bóng" initOpen={true} iconUp={IMAGE_ARROW_UP_LEAGUES} iconDown={IMAGE_ARROW_DOWN_LEAGUES}>
          <NoData />;
      </CollapsiblePanel>
    )
  }

  return (
    <CollapsiblePanel title="Dữ liệu đội bóng" initOpen={true} iconUp={IMAGE_ARROW_UP_LEAGUES} iconDown={IMAGE_ARROW_DOWN_LEAGUES}>
      <div className="flex flex-col justify-center items-center font-medium">
        <div className="w-full @md:w-[70%] dark:bg-league-header-dark dark:text-golden-yellow text-sm mt-2 mb-1">
          <div className="flex items-center justify-between text-white dark:text-stroke-o3 bg-button-blue-bet dark:bg-black rounded px-6 py-2">
            <p className="w-[3rem] text-center dark:text-stroke-o3">Chủ</p>
            <p className="text-center dark:text-stroke-o3">20 Trận Gần Nhất</p>
            <p className="w-[3rem] text-center dark:text-stroke-o3">Khách</p>
          </div>
          <div>
            {recentTeamPerf.map((data) => (
              <div className="flex items-center w-full px-6 py-3 bg-white dark:bg-dark-slate justify-between items-center mt-1">
                <p
                  className={`w-[3rem] text-center ${
                    data?.colorStatus === "1"
                      ? "text-vibrant-red"
                      : "text-button-blue-bet dark:text-stroke-o3"
                  }`}
                >
                  {data?.home}
                </p>
                <p className="text-button-blue-bet dark:text-stroke-o3">{data?.label}</p>
                <p
                  className={`w-[3rem] text-center ${
                    data?.colorStatus === "2"
                      ? "text-vibrant-red"
                      : "text-button-blue-bet dark:text-stroke-o3"
                  }`}
                >
                  {data?.away}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </CollapsiblePanel>
  );
}
